var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconHandshake(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1075 8.42125L14.5013 4.87625H8.7025C8.24875 4.87625 7.8075 5.03125 7.4525 5.315L6.04875 6.43875C5.69375 6.7225 5.25375 6.8775 4.79875 6.8775H3.5C2.9475 6.8775 2.5 7.325 2.5 7.8775V14.8775C2.5 15.43 2.9475 15.8775 3.5 15.8775H7.17125C7.70125 15.8775 8.21 16.0888 8.585 16.4638L10.585 18.4638C11.3663 19.245 12.6325 19.245 13.4138 18.4638L16.835 15.0425C17.6163 14.2613 17.6163 12.995 16.835 12.2138L14.6788 10.0575C14.2488 9.6275 14.0375 9.02625 14.105 8.4225L14.1075 8.42125Z",
    fill: "#FFD3C0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9539 6.4375L16.5502 5.31375C16.1952 5.03 15.7552 4.875 15.3002 4.875H14.3302C13.8002 4.875 13.2914 5.08625 12.9164 5.46125L8.0877 10.29C7.4877 10.89 7.4877 11.8625 8.0877 12.4612C8.86895 13.2425 10.1352 13.2425 10.9164 12.4612L12.5877 10.79C13.3689 10.0087 14.6352 10.0087 15.4164 10.79L16.0027 15.8762H20.5027C21.0552 15.8762 21.5027 15.4287 21.5027 14.8762V7.87625C21.5027 7.32375 21.0552 6.87625 20.5027 6.87625H19.2039C18.7502 6.87625 18.3089 6.72125 17.9539 6.4375Z",
    fill: "#FFB9A3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8373 12.2125L15.416 10.7912V15.8775H16.0023L16.8385 15.0412C17.6198 14.26 17.6198 12.9937 16.8385 12.2125H16.8373Z",
    fill: "#FFD3C0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHandshake);
export default __webpack_public_path__ + "static/media/icon_handshake.db274fa7.svg";
export { ForwardRef as ReactComponent };